/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jun 21 2023
 **/

// import { Properties } from "@/frameworks/libraries/properties";

export const Topics = {
	Common: "/topic/common/broadcast",
	Controls: "/user/direct",
	// For Handler
	Room: (channelID: string) => `/topic/chat/${channelID}`,
	Peer: (userID: string) => `/topic/public/user/${userID}`,
	Call: (callID: string) => `/topic/public/call/${callID}`,
	CallUser: (callID: string, userID: string) => `/topic/public/call/${callID}/${userID}`,
	Public: (subTopic: string) => `/topic/public${subTopic ? `${subTopic.startsWith("/") ? "" : "/"}${subTopic}` : ""}`,
	Conference: (roomId: string) => `/topic/conference/${roomId}`,
	Whiteboard: (whiteboardID: string) => `/topic/public/whiteboard/${whiteboardID}`,
	//use Only Unity
	Unity: `/topic/unity`,
	// For Actions
	ToRoom: (channelID: string) => `/app/chat/${channelID}`,
	ToPeer: (userID: string) => `/app/public/user/${userID}`,
	ToCall: (callID: string) => `/app/public/call/${callID}`,
	ToCallUser: (callID: string, userID: string) => `/app/public/call/${callID}/${userID}`,
	ToPublic: (subTopic: string) => `/app/public${subTopic ? `${subTopic.startsWith("/") ? "" : "/"}${subTopic}` : ""}`,
	ToWhiteboard: (whiteboardID: string) => `/app/public/whiteboard/${whiteboardID}`
};

export const InitialSubscribeTopics = () => {
	return [Topics.Common, Topics.Controls];
};
